import OrderServeType from '@/constants/OrderServeType';
import { isEmpty } from 'lodash';

const checkNameRequired = (webStoreVo, serveType, selectedTakeOutServeType) => {
  if (isEmpty(webStoreVo)) return false;
  const {
    webUiConfig: { enableInputName },
  } = webStoreVo || {};

  if (
    serveType === OrderServeType.TAKE_OUT &&
    selectedTakeOutServeType === OrderServeType.TAKE_OUT &&
    enableInputName
  ) {
    return true;
  }

  if (
    serveType === OrderServeType.TAKE_OUT &&
    selectedTakeOutServeType === OrderServeType.SCHEDULE_TAKE_OUT
  ) {
    return false;
  }

  if (serveType === OrderServeType.DELIVERY) {
    return true;
  }
  return false;
};

export default checkNameRequired;
